import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
import Input from 'components/shared/FormElements/Input/textarea';
import useFormData from '../../../useFormData';

const Foi = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const { handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Check it we are facing an existing user
  const { ExistingUser } = useFormData();

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      {!ExistingUser && (
        <SectionStepInfo section="Section 2 of 4" description="About your enquiry" />
      )}

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">What is your freedom of information request?</h2>
        </legend>

        <Input
          className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
          name="InformationRequested"
          label="The information request is"
          fieldValidation={fieldValidation('The information request is')}
        />

        <Input
          className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
          name="ExtraDetails"
          label="Please add any details that will help clarify your request"
          fieldValidation={fieldValidation(
            'Please add any details that will help clarify your request'
          )}
        />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default Foi;
